import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import * as React from 'react';
import AppTheme from '../../theme/AppTheme';
import AppAppBar from './components/AppAppBar';
import FAQ from './components/FAQ';
import Features from './components/Features';
import Footer from './components/Footer';
import HeroExperiment from './components/HeroExperiment';
import Highlights from './components/Highlights';
import HowItWorks from './components/HowItWorks';
import { FONT_BODY, LandingFonts } from './components/LandingKit';
import Pricing from './components/Pricing';
import Problem from './components/Problem';
import Results from './components/Results';
import TrustBar from './components/TrustBar';

export default function MarketingPage(props) {
  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />
      <LandingFonts />
      <Box sx={{ fontFamily: FONT_BODY }}>
        <AppAppBar />
        <HeroExperiment />
        <TrustBar />
        <Problem />
        <Results />
        <Features />
        <HowItWorks />
        <Highlights />
        <Pricing />
        <FAQ />
        <Footer />
      </Box>
    </AppTheme>
  );
}
